import { Component, OnDestroy, OnInit, ViewChild, Inject, afterNextRender } from '@angular/core';
import { Router } from "@angular/router";
import { AppointmentsService } from '../../../services/appointments/appointments.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { AppointmentsFilterService } from '../../../services/appointments/appointments-filter.service';
import { MatTabsModule } from '@angular/material/tabs';
import { AppointmentDetailComponent } from './tabs/appointment-detail.component.js';
import { AppointmentAnswersComponent } from './tabs/appointment-answers.component.js';
import { AppointmentNoteComponent } from './tabs/appointment-note.component.js';
import { AppointmentPreVisitComponent } from './tabs/appointment-pre-visit.component.js';
import { AppointmentCodesComponent } from './tabs/appointment-codes.component.js';
import { AppointmentFilesComponent } from './tabs/appointment-files.component.js';

/** The appointments list page */
@Component({
	selector: 'app-appointment',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		AppointmentDetailComponent,
		AppointmentAnswersComponent,
		AppointmentNoteComponent,
		AppointmentCodesComponent,
		AppointmentPreVisitComponent,
		AppointmentFilesComponent
	],
	templateUrl: './appointment.component.html',
	styleUrl: './appointment.component.scss'
})
export class AppointmentComponent implements OnInit, OnDestroy {

	constructor(private appointmentsService: AppointmentsService,
		private appointmentsFilterService: AppointmentsFilterService,
		private router: Router) {
	}

	ngOnInit() {
	}

	private refresh() {
	}

	ngOnDestroy() {
	}
}
